import { render, staticRenderFns } from "./phoneNumberConfirmPopup.vue?vue&type=template&id=b0beb588&scoped=true"
import script from "./phoneNumberConfirmPopup.vue?vue&type=script&lang=js"
export * from "./phoneNumberConfirmPopup.vue?vue&type=script&lang=js"
import style0 from "./phoneNumberConfirmPopup.vue?vue&type=style&index=0&id=b0beb588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0beb588",
  null
  
)

export default component.exports